import {AppRoutes} from "./pages/AppRoutes.tsx";
import {AppLoad} from './widgets/Load/AppLoad.tsx';
import {AddProductsListToCartContextProvider} from "./widgets/providers/AddProductsListToCartContextProvider.tsx";
import {PersistGate} from "redux-persist/lib/integration/react";
import {persistor} from "@/utils/storage/stores/persistor.ts";
import {useEffect, useState} from "react";

/** Основной компонент приложения */
export const App = () => {
    const [isMounted, setIsMounted] = useState<boolean>(false);

    //Добавляем персистор после монтирования
    useEffect(() => {
        setIsMounted(true);
    }, []);

    /** Контент сайта без персистентной обёртки */
    const AppContent = () => {
        return (
            <AppLoad>
                <AddProductsListToCartContextProvider>
                    <AppRoutes/>
                </AddProductsListToCartContextProvider>
            </AppLoad>
        );
    };

    //До монтирования возвращаем сайт без персистора
    if (!isMounted) {
        return <AppContent/>;
    }

    //Добавляем персистор после монтирования
    return (
        <PersistGate loading={null} persistor={persistor}>
            <AppContent/>
        </PersistGate>
    );
};
